import { Row, Col, Card, Divider, Table, Tag } from "antd";
import "antd/dist/antd.css";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import DashboardNewService from "../../../../services/DashboardNew/DashboardNewService";



const LatestEvaluations = ({ dashboardData }) => {
    const token = useSelector((state) => state.Member.token);
    const [points, setPoints] = useState([]);
    const [loading, setLoading] = useState(false);


    const pointsTableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            align: "center",
            width: 50,
            render: (value) => <b>{value}</b>,
        },
        {
            title: "Tipi i aktivitetit",
            dataIndex: "activity_type",
            width: 250,
        },
        {
            title: "Aktiviteti",
            dataIndex: "activity_name",
            width: 250,
        },
        {
            title: "Pikët",
            dataIndex: "points",
            width: 100,
            align: "center",
            render: (text, record) => (
                <Tag color="geekblue">{parseInt(record.points)}</Tag>
            ),
        },
    ];


    useEffect(() => {
        setLoading(true);
        DashboardNewService.getDashboardPoints(token)
            .then((response) => {
                setPoints(response.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [token]);


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Divider orientation="left" style={{ borderTopColor: "#a461d852" }} className="m-0">
                            <h4 className="m-0" style={{ color: "#a461d8" }}>Vlerësimet e fundit</h4>
                        </Divider>
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "0px" }}>
                            <div className="table-responsive">
                                <Table
                                    size="small"
                                    columns={pointsTableColumns}
                                    rowKey="id"
                                    // bordered="true"
                                    dataSource={points}
                                    pagination={false}
                                    loading={loading}
                                    showHeader="true"
                                    scroll={{ x: 500 }}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default LatestEvaluations;